import { useEffect, useState } from 'react';

import WebApp from '@twa-dev/sdk';

export const useViewportHeight = () => {
  const [viewport, setViewport] = useState({
    height: WebApp.viewportHeight,
    stableHeight: WebApp.viewportStableHeight,
  });

  useEffect(() => {
    const handleViewportChanged = () => {
      setViewport({
        height: WebApp.viewportHeight,
        stableHeight: WebApp.viewportStableHeight,
      });
    };

    WebApp.onEvent('viewportChanged', handleViewportChanged);

    return () => {
      WebApp.offEvent('viewportChanged', handleViewportChanged);
    };
  }, []);

  return viewport;
};
